import React, { useEffect, useState } from "react";
import { tow_truck_no_bg } from "../../../images";
import { useSelector } from "react-redux";
import { generateQuotingPriceRequest } from "../../../services/agentlessFormService";
import { toast } from "react-toastify";
import FormRadioGroup from "../../../components/molecules/FormRadioGroup";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { getLeadsById } from "../../../services/leads";
import errorMessage from "../../../util/errorMessage";
import { DotsLoader, FormInput, FormSelectInput } from "../../../components";
import { useNavigate } from "react-router-dom";
import LeadRejectForm from "../../Client/View/ServiceForm/LeadRejectForm";
import labels from "./leads_labels.json";
import axios from "axios";
function QuoteModal({
  formik,
  onCancelModal,
  modalClass,
  childrenClass,
  id,
  lead_id,
  jobDetail,
}) {
  const { quote } = useSelector((state) => state.leads);
  const { record } = useSelector((state) => state.jobCategory);
  const [isRejectFormModal, setRejectFormModal] = React.useState(false);
  const [isSchedule, setIsSchedule] = React.useState("false");
  const [isLoader, setIsLoader] = useState(false);
  const [weatherData, setWeatherData] = useState(null);
  const [isWeatherInCelc, setIsWeatherInCelc] = useState(true);
  const [isInMiles, setIsInMiles] = useState(true);
  const navigate = useNavigate();
  const openRejectFormHandler = () => {
    const c = window.confirm(`Are you sure you want to decline this job?`);
    if (c) {
      setRejectFormModal(true);
    }
  };
  const cancelFormHandler = () => {
    setRejectFormModal(false);
  };
  const generate_quoting_price_request = async () => {
    setIsLoader(true);
    try {
      const res = await generateQuotingPriceRequest(lead_id);
      if (res.status === 200 || res.status === 201) {
        formik?.setValues({
          ...formik?.values,
          quoting_request_status: res.data?.quoting_request_status,
        });
        toast.success(res.data.message || "Quoting request sent successfully");
      } else {
        toast.error(res.data.message || "Quoting request couldn't be send");
      }
    } catch (err) {
      toast.error(
        err?.response.data.message || "Quoting request couldn't be send"
      );
      console.log("👊 ~ constgenerate_quoting_price_request=async ~ err:", err);
    }
    setIsLoader(false);
  };
  useEffect(() => {
    const getLeadDetail = async () => {
      try {
        const res = await getLeadsById(lead_id);
        if (res?.status === 200) {
          formik.setValues({
            ...res.data,
            id: lead_id,
            service_name: record?.records?.find(
              ({ _id }) => _id === res.data?.job_category_id
            )?.name,
          });
        }
      } catch (error) {
        console.error(
          "Error ~ file: AddUpdateForm.jsx:157 ~ getJob ~ error",
          error
        );
        errorMessage({
          payload: error?.response?.data?.message,
          action: "Lead",
          msg: "loaded",
        });
      }
    };
    const intervalId = setInterval(() => {
      if (formik.values.quoting_request_status === "Pending") {
        getLeadDetail();
      } else {
        clearInterval(intervalId);
      }
    }, 10000);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.quoting_request_status]);

  const formatValue = (val) => {
    if (typeof val !== "boolean" && !val) return null;
    if (typeof val === "boolean") {
      return val ? "Yes" : "No";
    }
    if (val && !val.includes("_")) return val;
    return val
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  const renderItem = (label, value) => (
    <div className="flex gap-x-1">
      <label className="text-client-50">{label}</label>{" "}
      <span>{formatValue(value)}</span>
    </div>
  );
  const renderItemHeader = (label, secondary, value) => (
    <div className="flex justify-between items-center border-b border-client-50 pb-1.25 ml-2.5 mb-1.25">
      <div className="col-span-1 text-client-100  pl-0  font-bold">{label}</div>
      {secondary ? (
        <div className="font-bold">
          <label className="text-client-100">{secondary}</label>{" "}
          <span>{value}</span>
        </div>
      ) : null}
    </div>
  );
  const hasKey = (obj, searchedKey) => {
    return Object.keys(obj).some((key) => key.includes(searchedKey));
  };
  useEffect(() => {
    if (formik.values?.pickup_latitude && formik.values?.pickup_longitude) {
      const fetchWeather = async () => {
        try {
          const response = await axios.get(
            `https://api.weatherapi.com/v1/current.json?key=aef9e2f1f19d41b49ed152539241911&q=${formik.values?.pickup_latitude},${formik.values?.pickup_longitude}&aqi=no`
          );
          setWeatherData(response.data);
        } catch (error) {
          console.error("Error fetching weather data:", error);
        }
      };

      fetchWeather();
    }
  }, [formik.values]);

  const convertDistance = (distanceInMiles) => {
    // Conversion factor for miles to kilometers
    const MILES_TO_KM = 1.60934;

    if (isInMiles) {
      return `${distanceInMiles} `;
    } else if (!isInMiles) {
      const distanceInKm = (distanceInMiles * MILES_TO_KM).toFixed(2); // Convert and round to 2 decimal places
      return `${distanceInKm} `;
    } else {
      throw new Error("Invalid unit. Please use 'miles' or 'km'.");
    }
  };
  return (
    <div className="w-full h-screen z-[100] fixed top-0 left-0 opacity-100 bg-black/[0.75] flex items-center justify-center">
      {isLoader ? <DotsLoader /> : null}
      {isRejectFormModal && (
        <LeadRejectForm
          modalTitle="Decline Lead"
          onCancelForm={cancelFormHandler}
          leadId={lead_id}
        />
      )}
      <div className="relative max-w-[80%]">
        <div className="absolute top-0 right-0 p-2 z-20 -mt-6 -mr-6">
          <button
            onClick={onCancelModal}
            className="bg-white rounded-full text-gray-700 hover:text-red-500 p-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div
          className={`relat z-10 w-auto w-full md:max-w md:min-w-[730px] max-h-[calc(100vh-130px)] overflow-y-auto bg-neutral-100 p-3.5 border-[10px] border-white ${modalClass}`}
          //   ref={modalRef}
        >
          {jobDetail ? (
            <div className="container-fluid mt-2 text-center">
              <div className="inline-block bg-white my-0 mx-auto p-4">
                <div className="w-[100px] h-[100px] bg-[#3dcb31] rounded-full m-auto mt-[-70px] flex justify-center items-center">
                  <i className="text-white font-extrabold text-5xl text-center">
                    ✓
                  </i>
                </div>
                <label className="text-black font-pop text-3xl mb-2.5 font-medium">
                  Thank You!
                </label>
                <p className="text-[#7b828a] font-pop text-base m-0">
                  Your Service request has been recived. Your job number is{" "}
                  <span
                    className="text-[#027bff]"
                    onClick={() => {
                      onCancelModal();
                      navigate(`/jobs/update/${lead_id}`);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    {jobDetail?.job_number}
                  </span>
                  . Call or text us on this{" "}
                  <span className="text-[#027bff]">
                    {" "}
                    {jobDetail?.call_text_on}
                  </span>{" "}
                  for any query.
                </p>
              </div>
            </div>
          ) : (
            <div className="pt-0 w-auto px-3.5 m-auto ">
              <div className={`md:p-4 ${childrenClass}`}>
                <div className="relative flex gap-x-2 ml-3 w-auto">
                  <div className="min-w-[200px]">
                    <FormSelectInput
                      name="payment_type"
                      label="Type of Call"
                      formik={formik}
                      options={[
                        { label: "C.O.D", value: "COD" },
                        { label: "Insurance", value: "Insurance" },
                      ]}
                      labelProp="label"
                      valueProp="value"
                      nullOption="No"
                      className="w-[200px]"
                    />
                  </div>

                  {formik.values?.payment_type === "Insurance" ? (
                    <div className="flex flex-row gap-x-2">
                      <FormSelectInput
                        name="extra_fields.insurance_name"
                        options={[
                          { value: "Allstate", label: "Allstate" },
                          { value: "Honk", label: "Honk" },
                          { value: "Agero", label: "Agero" },
                          { value: "AXA", label: "AXA" },
                          { value: "Geico", label: "Geico" },
                          { value: "Urgently", label: "Urgently" },
                          { value: "NSD", label: "NSD" },
                          { value: "AAA", label: "AAA" },
                          {
                            value: "Roadside Protect",
                            label: "Roadside Protect",
                          },
                          {
                            value: "National Auto Club",
                            label: "National Auto Club",
                          },
                          {
                            value: "Allied Dispatch",
                            label: "Allied Dispatch",
                          },
                          { value: "Hertz", label: "Hertz" },
                          { value: "Quest", label: "Quest" },
                          {
                            value: "Pinnacle Motor Club",
                            label: "Pinnacle Motor Club",
                          },
                          { value: "Others", label: "Others" },
                        ]}
                        valueProp="value"
                        labelProp="label"
                        label="Insurance Name"
                        disabled={true}
                        formik={formik}
                        value={formik.values?.extra_fields?.insurance_name}
                        isCustomOption="Select an Insurance"
                      />
                      <FormInput
                        name="po_insurance"
                        type="text"
                        placeholder="PO Insurance"
                        formik={formik}
                        disabled={true}
                      />
                    </div>
                  ) : null}

                  <FormInput
                    name="distance"
                    label="Distance (miles)"
                    formik={formik}
                    type="text"
                    disabled
                  />
                </div>
                <div
                  className={["flex md:flex-row flex-col gap-x-2"].join(" ")}
                >
                  <div className="sm:col-span-12 md:col-span-3 mb-4 md:!mb-0  bg-white rounded-2xl shadow-client">
                    <div className="flex justify-center items-center flex-col p-4">
                      <h5 className="text-client-100 pb-2.5 w-full border-b border-client-100">
                        Here is the estimated cost of your service.
                      </h5>
                      <img
                        src={tow_truck_no_bg}
                        alt=""
                        className="w-full max-w-[300px]"
                      />
                      <h2 className="mt-5">
                        Best price - {quote?.currency}
                        {formik?.values?.quoting_request_price ||
                          quote?.service_cost}
                      </h2>
                      <div className="text-center">
                        {formik?.values?.quoting_request_status ===
                        "Pending" ? (
                          <div className="text-sm">
                            Your request has been sent, please wait for
                            approval.
                          </div>
                        ) : formik?.values?.quoting_request_status ===
                          "Quoted" ? (
                          <div className="text-green-600 !mt-4">
                            Your request has been approved.
                          </div>
                        ) : formik?.values?.quoting_request_status ===
                          "Rejected" ? (
                          <div className="text-red-600 !mt-4">
                            Your request has been rejected.
                          </div>
                        ) : (
                          <div className="text-sm">
                            Do you want to send this price to Quoting Team?{" "}
                            <button
                              className="text-blue-500 cursor-pointer hover:underline"
                              onClick={generate_quoting_price_request}
                            >
                              Click here
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="sm:col-span-12 md:col-span-6 p-4 bg-white rounded-2xl shadow-client w-full">
                    <h5 className="text-client-100 pb-2.5 w-full border-b border-client-100">
                      Review your information
                    </h5>

                    {/* Basic  Information */}
                    <div>
                      {renderItemHeader(
                        "Basic Information",
                        "Lead Number:",
                        formik?.values?.lead_num
                      )}
                      <div className="ml-3 grid grid-cols-1">
                        {renderItem("Name:", formik?.values.name)}
                        {renderItem("Phone:", formik?.values.phone)}
                        {renderItem(
                          "Alternate No:",
                          formik?.values.alternate_phone
                        )}
                        {renderItem("Email:", formik?.values.email)}
                      </div>
                    </div>
                    {/* Pickup & Drop Location */}
                    <div>
                      {renderItemHeader("Pickup & Drop Location")}
                      <div className="ml-3 grid grid-cols-1">
                        <div className="grid grid-cols-4 gap-x-3">
                          <div className="col-span-3">
                            {renderItem(
                              "Pickup Address:",
                              formik?.values?.complete_pickup_address
                            )}
                            {formik?.values?.complete_drop_address
                              ? renderItem(
                                  "Drop Address:",
                                  formik?.values?.complete_drop_address
                                )
                              : null}
                          </div>
                          <div className="col-span-1">
                            {renderItem(
                              "Weather Condition:",
                              weatherData
                                ? weatherData?.current?.condition?.text
                                : ""
                            )}
                            <div className="flex gap-x-1">
                              <label className="text-client-50">
                                {"Weather Temp:"}
                              </label>{" "}
                              {weatherData?.current ? (
                                <span>
                                  {isWeatherInCelc
                                    ? `${weatherData?.current?.temp_c || ""}`
                                    : `${
                                        weatherData?.current?.temp_f || ""
                                      }`}{" "}
                                  <span
                                    className="text-blue-500 hover:underline cursor-pointer"
                                    onClick={() =>
                                      setIsWeatherInCelc(!isWeatherInCelc)
                                    }
                                  >
                                    °{isWeatherInCelc ? "C" : "F"}
                                  </span>
                                </span>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        {formik?.values.complete_drop_2_address
                          ? renderItem(
                              "2nd Drop off Address:",
                              formik?.values.complete_drop_2_address
                            )
                          : null}
                        {formik?.values.distance ? (
                          <div className="flex gap-x-1">
                            <label className="text-client-50">
                              {"Distance:"}
                            </label>{" "}
                            <span>
                              {convertDistance(formik?.values.distance)}{" "}
                              <span
                                className="text-blue-500 hover:underline cursor-pointer"
                                onClick={() => setIsInMiles(!isInMiles)}
                              >
                                {isInMiles ? "miles" : "km"}
                              </span>
                            </span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* Service & Car Info */}
                    <div>
                      {renderItemHeader("Additional Info/Instructions")}
                      <span className="ml-3">
                        {formik?.values?.special_instruction || ""}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="p-4 bg-white rounded-2xl shadow-client mt-2">
                  <div>
                    <div className="flex items-center border-b border-client-50 pb-1.25 ml-2.5 mb-1.25 gap-x-4">
                      <div className="col-span-1 text-client-100  pl-0  font-bold">
                        Service & Car Info
                      </div>
                      <div className="flex-1 flex justify-cente transform translate-x-1/4">
                        <div className="font-bold">
                          <label className="text-client-100">
                            Type of Service:
                          </label>{" "}
                          <span>{formik?.values?.service_name}</span>
                        </div>
                      </div>
                    </div>
                    {formik?.values?.extra_fields ? (
                      <>
                        <div className="ml-3 grid grid-cols-3 gap-x-4 gap-y-1">
                          {Object.keys(formik?.values?.extra_fields)
                            ?.filter(
                              (key) =>
                                !key.includes("replacement_car") &&
                                key !== "replacement_license_number" &&
                                key !== "insurance_name"
                            )
                            ?.map((key) => {
                              // Find the label from the `labels` object using the key
                              const label = labels[key] || key; // If no label is found, fall back to the key itself
                              return renderItem(
                                label,
                                formik?.values?.extra_fields[key]
                              );
                            })}
                        </div>
                        {hasKey(
                          formik?.values?.extra_fields,
                          "replacement_car"
                        ) ? (
                          <div className="col-span-3">
                            {renderItemHeader("Replacement vehicle")}
                            <div className="ml-3 grid grid-cols-3 gap-x-4 gap-y-1">
                              {Object.keys(formik?.values?.extra_fields)
                                ?.filter(
                                  (key) =>
                                    key.includes("replacement_car") ||
                                    key === "replacement_license_number"
                                )
                                ?.map((key) => {
                                  const label = labels[key] || key;
                                  return renderItem(
                                    label?.replace("Replacement vehicle ", ""),
                                    formik?.values?.extra_fields[key]
                                  );
                                })}
                            </div>
                          </div>
                        ) : null}
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
              <div>
                <FormRadioGroup
                  name="schedule_on"
                  labelProp="label"
                  valueProp="value"
                  options={[
                    { label: "I want driver to come now.", value: "false" },
                    {
                      label: "I want to schedule a driver for later.",
                      value: "true",
                    },
                  ]}
                  isCheck={isSchedule}
                  isOnChange={(ele) => setIsSchedule(ele)}
                  type="text"
                  isRadio={true}
                  convertor={(value) => value === "true"}
                  isFloat={false}
                />
                {isSchedule === "true" && (
                  <div className="mb-2 flex justify-start items-center col-md-6">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        value={formik?.values?.scheduled_on}
                        onChange={(val) => {
                          formik?.setFieldValue("scheduled_on", val.toString());
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                )}
              </div>
              <div className="flex flex-row gap-x-2 justify-end">
                {formik.values?.quoting_request_status &&
                (formik.values?.quoting_request_status === "Quoted" ||
                  formik.values?.quoting_request_status === "Rejected") ? (
                  <button
                    type="button"
                    className="py-1.5 px-3 align-middle next rounded-0 text-white bg-client-100 border-client-100 float-right hover:bg-[#007bff]"
                    onClick={generate_quoting_price_request}
                  >
                    Re-Submit Quote
                  </button>
                ) : null}
                <button
                  type="button"
                  className="py-1.5 px-3 align-middle next rounded-0 text-white bg-red-400 float-right"
                  onClick={openRejectFormHandler}
                >
                  Decline Job
                </button>
                <button
                  type="submit"
                  className="py-1.5 px-3 align-middle next rounded-0 text-white bg-client-100 border-client-100 float-right hover:bg-[#007bff]"
                  onClick={formik.handleSubmit}
                >
                  Accept Payment, Pay later
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default QuoteModal;
